import { convertToTitleCase } from "./convertToTitleCase";

export const getName = (person = {}, format = "default") => {
  const {
    extendedName,
    lastName = "",
    nameTitle = "",
    firstName = "",
    middleName = "",
  } = person;
  if (extendedName && format === "titlecase")
    return convertToTitleCase(extendedName);
  if (extendedName) return extendedName;

  const formatName = (name) => (name ? `${name} ` : "");

  switch (format) {
    case "lastFirst":
      return `${formatName(lastName).trim()}, ${formatName(
        nameTitle
      )}${formatName(firstName)}${middleName}`.trim();
    case "titlecase":
      return `${formatName(convertToTitleCase(firstName))}${formatName(
        convertToTitleCase(middleName)
      )}${formatName(convertToTitleCase(lastName))}${nameTitle}`.trim();
    default:
      return `${formatName(firstName)}${formatName(middleName)}${formatName(
        lastName
      )}${nameTitle}`.trim();
  }
};
